import React from 'react';

const MessageIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99935 12.5H10.0077M9.99935 5.83333V9.16667M18.3327 14.1667C18.3327 14.6087 18.1571 15.0326 17.8445 15.3452C17.532 15.6577 17.108 15.8333 16.666 15.8333H5.68935C5.24736 15.8334 4.8235 16.0091 4.51102 16.3217L2.67602 18.1567C2.59327 18.2394 2.48785 18.2957 2.37309 18.3186C2.25833 18.3414 2.13938 18.3297 2.03127 18.2849C1.92317 18.2401 1.83077 18.1643 1.76575 18.067C1.70074 17.9697 1.66603 17.8553 1.66602 17.7383V4.16667C1.66602 3.72464 1.84161 3.30072 2.15417 2.98816C2.46673 2.67559 2.89065 2.5 3.33268 2.5H16.666C17.108 2.5 17.532 2.67559 17.8445 2.98816C18.1571 3.30072 18.3327 3.72464 18.3327 4.16667V14.1667Z'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default MessageIcon;
